import React from 'react';
import {CircularProgress, FormControl, MenuItem, Select, SelectProps, Typography} from '@mui/material';
import {AppEllipsisTypography} from 'components/typographies';
import {SelectOptionsType} from 'global';

export type AppSelectProps = SelectProps & {
    options: SelectOptionsType[];
    isLoading?: boolean;
};

// ✅ Use forwardRef to allow MUI and react-hook-form to attach refs properly
export const AppSelect = React.forwardRef<HTMLDivElement, AppSelectProps>(
    ({fullWidth, required, id, label, options, isLoading = false, ...rest}, ref) => {
        return (
            <FormControl fullWidth={fullWidth} size="small">
                <Typography variant="body2" style={{marginBottom: '5px'}}>
                    {label} {required && <span style={{color: 'red'}}>*</span>}
                </Typography>
                <Select
                    {...rest}
                    ref={ref}
                    MenuProps={{
                        BackdropProps: {
                            style: {
                                backgroundColor: 'transparent',
                            },
                        },
                        PaperProps: {
                            ...rest.MenuProps?.PaperProps,
                            style: {
                                boxShadow: '10px black',
                                ...rest.MenuProps?.PaperProps?.style,
                            },
                        },
                    }}
                >
                    {!isLoading ? (
                        options.map(option => (
                            <MenuItem style={{paddingLeft: 10}} key={option.value} value={option.value}>
                                <span style={{display: 'flex', alignItems: 'center', width: '100%'}}>
                                    {(option as any).color && (
                                        <span
                                            style={{
                                                display: 'inline-block',
                                                width: 12,
                                                height: 12,
                                                backgroundColor: (option as any).color,
                                                borderRadius: '50%',
                                                marginRight: 8,
                                                flexShrink: 0,
                                            }}
                                        />
                                    )}
                                    <AppEllipsisTypography
                                        text={option.label}
                                        variant="body2"
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            color: (option as any).textColor,
                                        }}
                                    />
                                </span>
                            </MenuItem>
                        ))
                    ) : (
                        <MenuItem disabled>
                            <CircularProgress size={24} sx={{mr: 2}} />
                            Loading...
                        </MenuItem>
                    )}
                </Select>
            </FormControl>
        );
    },
);

AppSelect.displayName = 'AppSelect'; // Avoid anonymous component warnings

export default AppSelect;
